import { observer } from 'mobx-react-lite';
import { FC, ReactElement, useCallback } from 'react';

import { GroupsPlaceholder } from '@gem/components';

import { List } from 'APP/components/List/List';
import { User } from 'APP/store/Users/User/User';

import { IMyContactsPresenter, ISelectContactsPresenter } from '../../SelectContacts.types';
import { UserWithCheckbox } from '../UserWithCheckbox/UserWithCheckbox';
import styles from './MyContacts.styles.m.css';

interface IMyContactsProps {
  presenter: IMyContactsPresenter;
  selectContactsPresenter: ISelectContactsPresenter;
}

export const MyContacts: FC<IMyContactsProps> = observer(
  ({ presenter, selectContactsPresenter }) => {
    const renderItem = useCallback((contact: User): ReactElement => {
      return (
        <UserWithCheckbox
          user={contact}
          toggleUser={selectContactsPresenter.toggleContact}
          getIsSelected={selectContactsPresenter.getIsSelected}
        />
      );
    }, []);

    return (
      <List
        isLoading={presenter.isLoading}
        hasMore={presenter.hasMore}
        data={presenter.contacts}
        onEndReached={presenter.loadMore}
        keyExtractor={(contact): string => contact.id}
        renderItem={renderItem}
        SpinnerComponent={
          <GroupsPlaceholder
            count={10}
            className={styles.placeholders}
          />
        }
      />
    );
  }
);
